(() => {
  'use strict';

  const $ = (selector, parent = document) => parent.querySelector(selector);
  const $$ = (selector, parent = document) => [...parent.querySelectorAll(selector)];
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = String(text);
    return element;
  };
  let products = {};
  try { products = JSON.parse($('#home-product-data')?.textContent || '{}'); } catch (_) { /* Native forms remain usable. */ }

  const menuButton = $('.menu-button');
  const menu = $('#site-menu');
  const menuGroups = menu ? $$('[data-menu-group-toggle]', menu).map(toggle => ({
    toggle,
    panel: document.getElementById(toggle.getAttribute('aria-controls') || '')
  })).filter(group => group.panel && menu.contains(group.panel)) : [];
  function setMenuGroup(group, open, restoreFocus = true) {
    if (!open && restoreFocus && menu.open && group.panel.contains(document.activeElement)) group.toggle.focus();
    group.toggle.setAttribute('aria-expanded', String(open));
    group.panel.hidden = !open;
  }
  function resetMenuGroups(restoreFocus = true) {
    menuGroups.forEach(group => setMenuGroup(group, false, restoreFocus));
  }
  function syncMenuState() {
    if (!menu || !menuButton) return;
    menuButton.setAttribute('aria-expanded', String(menu.open));
    $$('[data-open-menu-group]').forEach(trigger => trigger.setAttribute('aria-expanded', String(menu.open)));
    menuButton.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
  }
  function closeMenu(restoreFocus = false) {
    if (!menu || !menuButton) return;
    const wasOpen = menu.open;
    resetMenuGroups();
    if (wasOpen) menu.close();
    syncMenuState();
    if (restoreFocus && wasOpen) menuButton.focus();
  }
  if (menuButton && menu && typeof menu.showModal === 'function') {
    syncMenuState();
    resetMenuGroups(false);
    menuGroups.forEach(group => group.toggle.addEventListener('click', () => {
      const open = group.toggle.getAttribute('aria-expanded') !== 'true';
      group.toggle.focus();
      menuGroups.forEach(other => setMenuGroup(other, other === group && open));
    }));
    menuButton.addEventListener('click', () => {
      if (menu.open) closeMenu(true);
      else { resetMenuGroups(false); menu.showModal(); syncMenuState(); }
    });
    $$('[data-open-menu-group]').forEach(trigger => trigger.addEventListener('click', () => {
      const group = menuGroups.find(item => item.toggle.id === trigger.dataset.openMenuGroup);
      if (!group) return;
      resetMenuGroups(false);
      if (!menu.open) menu.showModal();
      setMenuGroup(group, true, false);
      syncMenuState();
      group.toggle.focus();
    }));
    $('[data-menu-close]', menu)?.addEventListener('click', () => closeMenu(true));
    // Native modal dialogs provide focus containment and make the page inert.
    menu.addEventListener('cancel', event => {
      event.preventDefault();
      closeMenu(true);
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || event.ctrlKey || event.metaKey || event.altKey) return;
      const focusable = $$('a[href], button, input, select, textarea, [tabindex], [contenteditable="true"]', menu).filter(element => {
        const style = window.getComputedStyle(element);
        return element.tabIndex >= 0 && !element.matches(':disabled') && !element.closest('[hidden], [inert], [aria-hidden="true"]') && element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.visibility !== 'collapse';
      });
      if (!focusable.length) { event.preventDefault(); return; }
      const first = focusable[0], last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || !focusable.includes(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !focusable.includes(active))) {
        event.preventDefault();
        first.focus();
      }
    });
    menu.addEventListener('close', () => { resetMenuGroups(false); syncMenuState(); });
    menu.addEventListener('click', event => {
      if (event.target !== menu) return;
      const rect = menu.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeMenu(true);
    });
    $$('a', menu).forEach(link => link.addEventListener('click', event => {
      if (event.defaultPrevented) return;
      let destination = null;
      const keyboardNavigation = event.detail === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self');
      if (keyboardNavigation) {
        try {
          const url = new URL(link.href, window.location.href);
          const current = new URL(window.location.href);
          if (url.origin === current.origin && url.pathname === current.pathname && url.search === current.search && url.hash.length > 1) {
            destination = document.getElementById(decodeURIComponent(url.hash.slice(1)));
          }
        } catch (_) { /* Let native link navigation handle an invalid fragment. */ }
      }
      closeMenu();
      if (destination) {
        // Continue keyboard navigation in the destination section after closing.
        const previousTabIndex = destination.getAttribute('tabindex');
        if (previousTabIndex === null) {
          destination.setAttribute('tabindex', '-1');
          destination.addEventListener('blur', () => destination.removeAttribute('tabindex'), { once: true });
        }
        destination.focus({ preventScroll: true });
      }
    }));
  }

})();
